import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/offline.svg'


const _hoisted_1 = {
  key: 0,
  class: "b-network-listener"
}
const _hoisted_2 = { class: "b-network-listener__wrapper flex middle-xs center-xs" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  width: "24",
  height: "24",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "b-network-listener__content bold" }

import { computed, ComputedRef, onBeforeUnmount, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { useRoute } from 'vue-router';
  import { FlightSearch, Search } from '@/types';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkListener',
  setup(__props) {

  const store = useStore();
  const route = useRoute();
  const { t } = useI18n();

  let pingJob;
  const EVENTS = ['online', 'offline', 'load'];

  const networkEnable: ComputedRef<boolean> = computed(
    () => store.state.support.networkEnable,
  );
  const searchState: ComputedRef<Search.SearchState> = computed(
    () => store.state.search.searchState,
  );
  const aviaSearchState: ComputedRef<FlightSearch.SearchState> = computed(
    () => store.state.flight.searchState,
  );
  const needRefresh: ComputedRef<boolean> = computed(
    () => store.getters['hotel/needRefresh'],
  );

  onMounted(() => {
    addNavigatorListeners();
  });

  onBeforeUnmount(() => {
    removeNavigatorListeners;
  });

  function updateOnlineStatus() {
    fetch('https://api.ml.finalprice.com')
      .then(() => {
        const recovered = pingJob !== null;
        store.commit('support/setNetworkIsEnable', true);
        destroyPingJob();
        if (
          recovered &&
          route.name === 'search' &&
          searchState.value.isFailed()
        ) {
          store.dispatch('search/search');
        }

        if (recovered && route.name === 'hotel' && needRefresh.value) {
          store.dispatch('hotel/getHotel');
          store.dispatch('hotel/getOffers');
        }

        if (
          recovered &&
          route.name === 'flights-search' &&
          aviaSearchState.value.isFailed()
        ) {
          store.dispatch('flight/initSearchSession');
        }
        store.dispatch('support/checkRefreshTimeout', false);
      })
      .catch(e => {
        store.commit('support/setNetworkIsEnable', false);
        store.commit('hotel/setError', {
          header: 'Network error',
          message: t('errors.noInternet'),
        });
        pingForConnection();
      });
  }

  function pingForConnection() {
    destroyPingJob();
    pingJob = setInterval(() => {
      if (!document.hidden) {
        updateOnlineStatus();
      }
    }, 5000);
  }

  function destroyPingJob() {
    clearInterval(pingJob);
    pingJob = null;
  }

  function addNavigatorListeners() {
    EVENTS.forEach(event => window.addEventListener(event, updateOnlineStatus));
  }

  function removeNavigatorListeners() {
    EVENTS.forEach(event =>
      window.removeEventListener(event, updateOnlineStatus),
    );
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "snack" }, {
    default: _withCtx(() => [
      (!_unref(networkEnable))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('errors.noInternet')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})